"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPermissionPresent = void 0;
const fetchWrapper_1 = require("./fetchWrapper");
const isPermissionPresent = (src, permissionName, permissionType) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const headers = yield (0, fetchWrapper_1.getHeaders)();
        let url = `${src}/acsSessionRole?resource=${permissionName}&permission=${permissionType}&X-SessionId=${headers['X-SessionId']}`;
        const res = yield fetch(url, { headers });
        const { isExisted, errorMessage } = yield res.json();
        if (res.ok) {
            return isExisted;
        }
        else {
            throw new Error(errorMessage);
        }
    }
    catch (err) {
        console.log(err);
        return false;
    }
});
exports.isPermissionPresent = isPermissionPresent;
